/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Status_Missing_3Inputs */

const en_vc_status_missing_3 = /** @type {(inputs: Vc_Status_Missing_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most 3D beyond Revolve, and some raster effects`)
};

const zh_vc_status_missing_3 = /** @type {(inputs: Vc_Status_Missing_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`绕转以外的大部分 3D 功能，以及部分栅格效果`)
};

/**
* | output |
* | --- |
* | "Most 3D beyond Revolve, and some raster effects" |
*
* @param {Vc_Status_Missing_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_status_missing_3 = /** @type {((inputs?: Vc_Status_Missing_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Status_Missing_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_status_missing_3(inputs)
	return zh_vc_status_missing_3(inputs)
});
export { vc_status_missing_3 as "vc.status.missing.3" }